<div class="lvi-content">
    <div class="avatar">
        <i class="nio icon-frais"></i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a>{{ data.libelle }}</a>
        </div>
    </div>
</div>